@use "../../variables" as *;
@use "../../mixins" as *;

.filter-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1110;
  background-color: transparent;
  display: none;

  &.show {
    display: flex;
    flex-direction: column;
  }

  @include tablet {
    position: static;
    width: auto;
    height: auto;
    z-index: 0;
    background: $white;
    display: block;
  }

  .filter-content {
    display: none;
    width: 100vw;
    height: 100%;
    z-index: 2;
    background-color: $white;
    padding: 0;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    &.show {
      display: flex;
      flex-direction: column;
    }

    @include tablet {
      position: relative;
      top: 0;
      left: 0;
      z-index: 1;
      width: 16.25rem;
      height: auto;
      margin-top: 1.25rem;
      margin-right: 2.5rem;
    }

    @include desktop {
      padding: 0;
    }

    .filter-header {
      position: sticky;
      position: -webkit-sticky;
      top: 0;
      background-color: white;
      padding: 1rem 1.5rem 0;

      @include tablet {
        display: none;
      }
    }

    .delete-filters a {
      text-decoration: none;
      color: inherit;
    }

    .filter-body {
      color: $grey;
      padding: 1rem 1.5rem 1rem;

      @include tablet {
        padding: 0;
      }

      .custom-filters {
        margin-bottom: 2.25rem;
      }

      .default-filters {

        > div:first-child {
          margin-top: 0;
        }
      }

      .likes {
        font-size: 1.125rem;
        line-height: 1.125rem;
        margin-bottom: 2.25rem;
      }
    }

    .close {
      text-align: right;

      svg {
        cursor: pointer;
        fill: $grey;
        width: 1rem;
        height: 1rem;
      }
    }

    .header {
      padding-top: 1.5rem;
      padding-bottom: 1.25rem;

      .filters {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.75rem;
        font-weight: 300;
        color: $grey-text;

        > div {
          display: inline;
          margin-left: 1.5rem;

          &:first-child {
            margin-left: 0;
          }

          svg {
            width: 0.75rem;
            height: 0.75rem;
          }
        }
      }

      @include tablet {
        margin: 2.25rem 0 1.25rem;
      }
    }
  }


  .filter-footer {
    .product-count-button {
      width: 100%;
      height: 2.625rem;
      background: $grey-text-light;
      color: $white;
      font-size: 1rem;
      line-height: 0.625rem;
      border: none;
      outline: none;
      cursor: pointer;
    }

    @include tablet {
      display: none;
    }
  }

}
